
import { Link } from "react-router-dom";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card, CardHeader, CardContent, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { User } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

interface ProfileCardProps {
  user: {
    name?: string;
    photoUrl?: string;
    email?: string;
  } | null;
}

const ProfileCard = ({ user }: ProfileCardProps) => {
  const { profile } = useAuth();
  
  const getInitials = (name: string) => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();
  };

  const getProfilePath = () => {
    if (profile?.role === "psychologist") {
      return "/psychologist-profile";
    }
    return "/patient-profile";
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Perfil</CardTitle>
        <CardDescription>Seus dados pessoais</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col items-center text-center gap-4">
        <Avatar className="w-24 h-24">
          <AvatarImage src={user?.photoUrl} alt={user?.name} />
          <AvatarFallback className="text-xl">{user?.name ? getInitials(user.name) : "U"}</AvatarFallback>
        </Avatar>
        <div>
          <h3 className="text-xl font-medium">{user?.name}</h3>
          <p className="text-sm text-muted-foreground">{user?.email}</p>
        </div>
        <div className="w-full pt-4">
          <Button variant="outline" className="w-full" asChild>
            <Link to={getProfilePath()}>
              <User className="mr-2 h-4 w-4" />
              Editar Perfil
            </Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProfileCard;
